var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouthprivatetopupcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M17.968 15.504a5.577 5.577 0 0 0 3.504 5.168v9.84C21.472 32.432 19.92 34 18 34H9.504a3.486 3.486 0 0 1-3.488-3.488V5.488A3.486 3.486 0 0 1 9.504 2H18c1.92 0 3.472 1.568 3.472 3.488v4.848a5.577 5.577 0 0 0-3.504 5.168z",
    fill: "url(#9ncqp9dxla)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M6 5.488v25.024A3.486 3.486 0 0 0 9.488 34h2.08a3.496 3.496 0 0 1-3.488-3.488V5.488A3.496 3.496 0 0 1 11.568 2h-2.08A3.496 3.496 0 0 0 6 5.488z",
    fill: "url(#1n4u2t5eub)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.784 31.488a1.104 1.104 0 1 0 0-2.208 1.104 1.104 0 0 0 0 2.208z",
    fill: "url(#1io3yt76fc)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.552 21.072v9.44A3.496 3.496 0 0 1 20.064 34H9.488A3.496 3.496 0 0 1 6 30.512V5.488A3.496 3.496 0 0 1 9.488 2h10.576a3.496 3.496 0 0 1 3.488 3.488v4.448m0 11.136a5.568 5.568 0 0 0 0-11.136m0 11.136a5.568 5.568 0 0 1 0-11.136M6 27.152h17.552M13.408 5.648h2.752m7.392 8.032v3.584m-1.792-1.792h3.584",
    stroke: "url(#asyutray5d)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "9ncqp9dxla",
    x1: 4.235,
    y1: 19.714,
    x2: 21.53,
    y2: 19.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B066E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1n4u2t5eub",
    x1: 5.358,
    y1: 19.714,
    x2: 11.589,
    y2: 19.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B066E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1io3yt76fc",
    x1: 13.425,
    y1: 30.502,
    x2: 15.896,
    y2: 30.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B066E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "asyutray5d",
    x1: 3.335,
    y1: 19.714,
    x2: 29.207,
    y2: 19.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B066E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouthprivatetopupcode);
export default __webpack_public_path__ + "static/media/youthprivatetopupcode.128262ff8a4f1e1cc04fcd67f68db077.svg";
export { ForwardRef as ReactComponent };